import { DialogMaster } from "#core/components/dialog/Dialog"
import { useApiSend } from "#hooks/useApiSend"
import { STATUS } from "#performance-evaluation/constants"
import { evaluationPut } from "#performance-evaluation/services/api"
import { Stack, Typography } from "@mui/material"
import { useReloadRefresh } from "app/reload"
import { useState } from "react"

export default function MyTeamFinished({ open, setOpen }) {
	const { refresh } = useReloadRefresh()

	const [disabled, setDisabled] = useState(false)

	const success = () => {
		setOpen(false)
		refresh()
	}

	const end = () => {
		setDisabled(false)
	}

	const { fetch } = useApiSend(evaluationPut, { success, end })

	const handleSubmit = () => {
		setDisabled(true)
		fetch({ status: STATUS.COMPLETED })
	}

	return (
		<DialogMaster
			{...{
				open,
				setOpen,
				handleSubmit,
				title: "Finalizar evaluaciones",
				maxWidth: "sm",
				disabled,
			}}
		>
			<Stack spacing={1}>
				<Typography variant="body1" fontWeight={600}>
					¿Deseas finalizar todas las evaluaciones abiertas?
				</Typography>
				<Typography variant="body2" color="text.secondary">
					Las evaluaciones abiertas quedaran registradas como finalizadas.
				</Typography>
			</Stack>
		</DialogMaster>
	)
}
